import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-politica-privacidad',
  templateUrl: './politica-privacidad.component.html',
  styleUrls: ['./politica-privacidad.component.scss']
})
export class PoliticaPrivacidadComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  irAUrlAnterior() {
    this.location.back();
  }

}
